export function rehydrateError(error) {
    return Object.assign(Error(error.message), {
        name: error.name,
        stack: error.stack
    });
}
export function serializeError(error) {
    return {
        message: error.message,
        name: error.name,
        stack: error.stack
    };
}
